export enum GripperOrientation {
  LEFT = -90,
  FRONT = 0,
  RIGHT = 90,
  BACK = 180,
  BACK_ALT = -180,
  LEFT_ALT = 270,
  RIGHT_ALT = -270,
}
